var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCollectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3635 32.8906H2.63696C1.47203 32.8906 0.527588 31.9462 0.527588 30.7813V3.21876C0.527588 2.05382 1.47203 1.10939 2.63696 1.10939H12.9077C13.4672 1.10939 14.0037 1.33164 14.3993 1.72722L18.0002 5.32813H33.3635C34.5285 5.32813 35.4729 6.27257 35.4729 7.43751V30.7813C35.4729 31.9462 34.5285 32.8906 33.3635 32.8906Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0925 9.54688C22.533 9.54688 21.9966 9.76913 21.6009 10.1647L18 13.7656H2.63672C1.47178 13.7656 0.527344 14.7101 0.527344 15.875",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74609 9.54688H2.63672",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4727 11.6562C35.4727 10.4913 34.5282 9.54688 33.3633 9.54688H6.85547",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCollectionIcon);
export default __webpack_public_path__ + "static/media/file-collection-icon.a5071653287947c451bff983daa42a5d.svg";
export { ForwardRef as ReactComponent };